// Types
import {NextApiRequest} from "next";

// Constants
import {PM_EXECUTED_COOKIE_NAME, PM_JUST_EXECUTED_COOKIE_NAME} from "constants/shared/session";
import {FORMAZIONE_PAGE} from "constants/shared/pages";

export const buildLoginRequest = (relativeRedirectUrl: string | string[], prompt = true) : string => {
    const baseLoginUrl = process.env.NEXT_PUBLIC_BASE_LOGIN_URL;
    const oneIdClientId = process.env.NEXT_PUBLIC_ONEID_CLIENTID;
    const ssoUrl = process.env.NEXT_PUBLIC_SSO_URL;

    const encodedRedirectUrl = encodeUrlFromRelativeUrl(relativeRedirectUrl);
    const encodedFallbackUrl = encodeUrlFromRelativeUrl("/errors/Default.aspx");
    const redirectUri = encodeURIComponent(`${ssoUrl}?redirect_url=${encodedRedirectUrl}&fallback_url=${encodedFallbackUrl}`);

    return (
        `${baseLoginUrl}?client_id=${oneIdClientId}&response_type=code` +
        `&pfidpadapterid=ItalyCompositeAdapter&scope=openid+profile+email` +
        `${!prompt ? "&prompt=none" : ""}&redirect_uri=${redirectUri}`
    );
}

export const buildLogoutRequest = (relativeRedirectUrl: string): string => {
    const baseLogoutUrl = process.env.NEXT_PUBLIC_BASE_LOGOUT_URL;
    const ssoUrl = process.env.NEXT_PUBLIC_SSO_URL;

    const encodedRedirectAndFallbackUrl = encodeLogoutApiUrlFromRelativeUrl(relativeRedirectUrl);
    const redirectUri = encodeURIComponent(`${ssoUrl}?action=logout&redirect_url=${encodedRedirectAndFallbackUrl}&fallback_url=${encodedRedirectAndFallbackUrl}`);

    return `${baseLogoutUrl}?TargetResource=${redirectUri}&InErrorResource${encodedRedirectAndFallbackUrl}`;
}

export const buildPassiveModeRequest = (relativeRedirectUrl: string | string[]) : string => {
    return buildLoginRequest(relativeRedirectUrl, false);
}

export const shouldExecutePassiveMode = (req: NextApiRequest) => {
    const enablePassiveMode = process.env.NEXT_PUBLIC_ENABLE_PASSIVE_MODE === 'true';
    return enablePassiveMode && (isPageRequestFromAnotherSite(req) || isPassiveModeTimeoutExpired(req)) && isGetRequest(req);
};

const isPageRequestFromAnotherSite = (req: NextApiRequest): boolean => {
    const passiveModeJustExecutedCookie = req.cookies && req.cookies[PM_JUST_EXECUTED_COOKIE_NAME];
    if (passiveModeJustExecutedCookie && passiveModeJustExecutedCookie !== '') {
        return false;
    }

    const mainUrl = process.env.NEXT_PUBLIC_DOMAIN
    const requestUrl = new URL(mainUrl ? mainUrl : "");
    const urlReferrer = req.headers.referer ? new URL(req.headers.referer) : null;

    if (!urlReferrer) {
        return false;
    }

    return requestUrl.host !== urlReferrer.host;
};

const isPassiveModeTimeoutExpired = (req: NextApiRequest): boolean => {
    const passiveModeExecutedCookie = req.cookies && req.cookies[PM_EXECUTED_COOKIE_NAME];
    return !(passiveModeExecutedCookie && passiveModeExecutedCookie !== '');
};

const isGetRequest = (req: NextApiRequest): boolean => {
    return req.method?.toUpperCase() === 'GET';
};

const encodeUrlFromRelativeUrl = (path: string | string[]) => {
    const normalizedPath = Array.isArray(path) ? path[0] : path;
    const domain = process.env.NEXT_PUBLIC_DOMAIN;
    const separator = normalizedPath.startsWith("/") ? "" : "/";

    return encodeURIComponent(`${domain}${separator}${normalizedPath}`);
};

const encodeLogoutApiUrlFromRelativeUrl = (path: string | string[]) => {
    const normalizedPath = Array.isArray(path) ? path[0] : path;
    const domain = process.env.NEXT_PUBLIC_DOMAIN;
    const separator = normalizedPath.startsWith("/") ? "" : "/";

    return encodeURIComponent(`${domain}${FORMAZIONE_PAGE}/api/handleLogout?redirectUrl=${separator}${normalizedPath}`);
};
